import React, { useState } from 'react'
import { Button, message, Modal, Upload } from 'antd'
import { SendOutlined, SyncOutlined } from '@ant-design/icons'
import { blue } from '../../../color'
import { observer } from 'mobx-react'
import uploadMyFileStore from './uploadMyFileStore'

const UploadMyFileModal = props => {
  const { visible, parentFolderId, typeTab, onClose, fileStore } = props
  const { isLoading } = uploadMyFileStore
  const [fileList, setFileList] = useState([])

  const handleImportFile = async () => {
    if (fileList.length === 0) {
      return message.warning('Hãy chọn file!')
    }

    try {
      uploadMyFileStore.isLoading = true
      const formData = new FormData()
      const file = fileList[0]
      formData.append('file', fileList[0])
      const { data } = await fileStore.uploadFile(formData)
      const fileParam = {
        name: data.file_name,
        parentId: parentFolderId,
        gridFsFileId: data.file_id,
        size: file.size,
        mimeType: file.type,
        typeTab,
      }
      await uploadMyFileStore.create(fileParam)
      closeAndResetForm()
      message.success('Tải file thành công')
    } catch (err) {
      if (err?.errorCode === 'FILE_NAME_DUPLICATE') {
        message.error('Tên file đã tồn tại')
      } else {
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      }
    } finally {
      uploadMyFileStore.isLoading = false
    }
  }

  const handleChangeFile = info => {
    setFileList([info.file])
  }

  const closeAndResetForm = () => {
    setFileList([])
    onClose()
  }

  return (
    <Modal
      title="Tải file lên thư mục"
      footer={null}
      closable={true}
      visible={visible}
      onCancel={closeAndResetForm}>
      <Upload
        valuePropName="fileList"
        fileList={fileList}
        onChange={handleChangeFile}
        beforeUpload={() => false}
        showUploadList={true}>
        <Button
          icon={<SyncOutlined />}
          style={{ color: blue, fontWeight: 500 }}>
          Chọn file
        </Button>
      </Upload>

      <Button
        style={{ marginTop: 16, width: '100%' }}
        icon={<SendOutlined />}
        loading={isLoading}
        onClick={handleImportFile}
        type="primary">
        Tải lên
      </Button>
    </Modal>
  )
}

export default observer(UploadMyFileModal)

